/** @jsxImportSource @emotion/react */
"use client";

import type { Interpolation } from "@emotion/react";

import { useThemeValues } from "../../../../../hooks/useThemeValues";
import type { HallowElement } from "../../../../../types/hallowElement.types";
import type { HallowElementProps } from "../../../../../types/hallowElementProps.types";
import { Text } from "../../../_core/Text/Text.emotion";

const hallowElement: HallowElement = "svg";

const textStyle: Interpolation = {
  textAlign: "center",
};

export type TickProps = HallowElementProps<typeof hallowElement> & {
  /** Data index of the leftmost labelled point, anchored inside the chart */
  firstLabelIndex?: number;
  /** Data index of the rightmost labelled point, anchored inside the chart */
  lastLabelIndex?: number;
  payload?: any;
} & any;

export const Tick = ({
  dataLength,
  payload,
  tickFormatter,
  verticalAnchor,
  visibleTicksCount,
  x,
  y,
  ...props
}: TickProps) => {
  const theme = useThemeValues();

  if (!payload.value) return null;

  return (
    <g transform={`translate(${x},${y})`} {...props}>
      <Text asChild size="l" css={textStyle} type="detail">
        <text
          dy={8}
          x={0}
          y={0}
          textAnchor={
            payload?.index === 0
              ? "start"
              : payload?.index + 1 === dataLength
                ? "end"
                : "middle"
          }
          fill={theme?.semanticColors?.neutralsLow}
        >
          {payload.value.replace("\n", "\t")}
        </text>
      </Text>
    </g>
  );
};

Tick.displayName = "Tick";
